interface InputsData {
    name: string;
    email: string;
    subject?: string;
    siteUrl?: string;
    theme: string;
    request: string;
}

export const getFormData = (data: InputsData, acceptedFiles: File[]) => {
    const formData = new FormData();
    formData.append('email', data.email);
    formData.append('name', data.name);
    formData.append('request', data.request);
    formData.append('theme', data.theme);

    if (data.subject) {
        formData.append('subject', data.subject);
    }

    if (acceptedFiles.length) {
        formData.append(`file`, acceptedFiles[0]);
    }

    if (data.siteUrl) {
        formData.append('siteUrl', data.siteUrl);
    }

    return formData;
};
